// extracted by mini-css-extract-plugin
export default {"receivedMessage":"ChatScreen_receivedMessage__R7owN","sentMessage":"ChatScreen_sentMessage__e+6oG"};